document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {
        if ( document.querySelectorAll('.jobFeature').length ) {

            const elements = document.querySelectorAll('.jobFeature');
            elements.forEach(function(element) {

                let timeline = gsap.timeline({defaults: {autoAlpha: 0, ease: "none"}});

                timeline
                    .from(element.querySelector('h2'), {x: -10, y: -20, ease:"power2.out", duration: .6})
                    .from(element.querySelectorAll('.entry'), {stagger:{grid: "[3,1]", from: "[1,1]", axis: "x", ease:"none", each: .1}}, "<")
                    .from(element.querySelector('.button'), {y: 10, duration: .3},"<")
                ;

                ScrollTrigger.create({
                    trigger: element,
                    animation: timeline,
                    start: "top 70%",
                    end: "bottom 70%",
                    toggleActions: "play none none none",
                    //markers: true
                });
            });
        }
    });
});
